<template>

    <v-badge
      :color="ColorBadge"
      :value="ColorBadge"
      :content="unreadCount"
      overlap
      :dot="!unreadCount"
     >

        <v-tooltip 
        :disabled="!tooltip"
        bottom>
          <template v-slot:activator="{ on, attrs }">

            <span v-bind="attrs" v-on="on">
              <v-avatar v-if="avatar" :size="`${SizeAvatarDefault}px`">
                  <v-img :src="`${$store.state.urlPathPhoto}/storage/user_photo/${user_id}/50/${avatar}`"></v-img>
              </v-avatar>
              <v-icon v-else :size="`${SizeIconDefault}px`">{{ `${(group === 1) ? 'mdi-account-group' : 'mdi-account'}` }}</v-icon>
            </span>

          </template>
          <span v-if="tooltip">{{ tooltip }}</span>
        </v-tooltip>

    </v-badge>


</template>

<script>

export default {


// если на вход подать :key="user_id"  то компонент обновиться
// group 1 это иконка группы 2 пользователь
// tooltip если есть то показывать подсказку 
// unreadCount количество непрочитанных сообщений

  props: ['user_id', 'fio', 'avatar', 'sizeavatar', 'sizeicon', 'group', 'tooltip', 'online', 'unreadCount', 'offUser'],

  data() {
    return {
      componentKey: 0,
      NewMail: false
    }
  },


  computed:{


    SizeIconDefault(){
      return (this.sizeicon) ? this.sizeicon : 36
    },

    SizeAvatarDefault(){
      return (this.sizeavatar) ? this.sizeavatar : 36
    },

    StateBadge(){
      //if(this.unreadCount){

        return Number(this.unreadCount) 
      //}
    },


    ColorBadge(){


      if(this.online === 1 || this.online == 'online'){
        return 'green'
      }else if(this.offUser === 0){
        return 'red'
      }else if(this.unreadCount){
        return 'grey'
      }else{
        return null
      }
    }

  },

  methods: {
    forceRerender() {
      this.componentKey += 1;  
    },
  }

  


};
</script>
